<template>
    <v-container fluid>
        <v-combobox
            v-model="selected"
            :items="logos"
            label="chọn logo watermark"
            dense
            append-icon=""
            persistent-hint
            item-text="title"
            item-value="src"
            @change="onLogoChange"
        >
            <template v-slot:append-outer>
                <v-btn
                    v-if="
                        selected &&
                        selected.title !== 'none' &&
                        !selected.children
                    "
                    icon
                    @click="editLogo"
                >
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="addLogo">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
        </v-combobox>
        <v-dialog max-width="800" v-model="values.visible" persistent>
            <template :v-slot:default="values.visible">
                <v-card>
                    <v-toolbar color="primary" dark>
                        {{ selected.index > 0 ? "Sửa logo" : "Thêm mới logo" }}
                    </v-toolbar>
                    <bot-spinner v-model="spinner">
                        <v-card-text>
                            <v-form
                                v-model="isValid"
                                ref="form"
                                class="mt-4"
                                @submit.prevent="submit"
                            >
                                <bot-upload-images
                                    ref="botImg"
                                    caption="logo"
                                    v-model="selected"
                                />
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            autofocus
                                            v-model="selected.title"
                                            label="Tên logo (1-100)"
                                            :rules="[
                                                (value) =>
                                                    vld.text({
                                                        field: 'tên logo',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.resize"
                                            label="logo zoom (1-100)"
                                            type="number"
                                            :rules="[
                                                (value) =>
                                                    vld.percentage({
                                                        field: 'logo zoom',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.margin"
                                            label="Canh lề (1-100)"
                                            type="number"
                                            :rules="[
                                                (value) =>
                                                    vld.percentage({
                                                        field: 'canh lề',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.opacity"
                                            label="Độ mờ (1-100)"
                                            type="number"
                                            :rules="[
                                                (value) =>
                                                    vld.percentage({
                                                        field: 'độ mờ',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row> </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.latitudeDegrees"
                                            label="Vĩ độ"
                                            type="number"
                                            :rules="[
                                                (value) =>
                                                    vld.number({
                                                        field: 'vĩ độ',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.longitudeDegrees"
                                            label="Kinh độ"
                                            type="number"
                                            :rules="[
                                                (value) =>
                                                    vld.number({
                                                        field: 'kinh độ',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.Copyright"
                                            label="Doanh nghiệp"
                                            :rules="[
                                                (value) =>
                                                    vld.text({
                                                        field: 'doanh nghiệp',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.Rating"
                                            label="Đánh giá"
                                            type="number"
                                            :rules="[
                                                (value) =>
                                                    vld.number({
                                                        field: 'đánh giá',
                                                        min: 1,
                                                        max: 5,
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.XPComment"
                                            label="Bình luận mặc định"
                                            :rules="[
                                                (value) =>
                                                    vld.text({
                                                        field: 'bình luận',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="selected.XPAuthor"
                                            label="Tác giả mặc định"
                                            :rules="[
                                                (value) =>
                                                    vld.text({
                                                        field: 'tác giả',
                                                        value,
                                                    }),
                                            ]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox
                                            v-model="selected.XPKeywords"
                                            chips
                                            clearable
                                            label="Từ khóa"
                                            append-icon=""
                                            multiple
                                            solo
                                        >
                                            <template
                                                v-slot:selection="{
                                                    attrs,
                                                    item: chip,
                                                    select,
                                                    selected: slt,
                                                }"
                                            >
                                                <v-chip
                                                    v-bind="attrs"
                                                    :input-value="slt"
                                                    close
                                                    @click="select"
                                                    @click:close="
                                                        removeKeyword(chip)
                                                    "
                                                >
                                                    {{ chip }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                            <v-btn
                                color="success darken-1"
                                text
                                @click="submit"
                            >
                                <v-icon left> mdi-check </v-icon>
                                Cập nhật
                            </v-btn>
                            <v-btn
                                color="pink"
                                text
                                @click="values.visible = false"
                            >
                                <v-icon left> mdi-close </v-icon>
                                Hủy
                            </v-btn>
                        </v-card-actions>
                    </bot-spinner>
                </v-card>
            </template>
        </v-dialog>
    </v-container>
</template>

<script>
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            tool: {
                file: {
                    metadata: {
                        updateLogo: "tool/file/metadata/updateLogo",
                        addLogo: "tool/file/metadata/addLogo",
                    },
                },
            },
        },
        selected: {
            index: -1,
            aspectRatio: 0,
            caption: "logo",
            resize: 40,
            margin: 50,
            opacity: 15,
            title: "Logo Bot Isaura",
            src: "/public/images/logo/logo-isaura.png",
            latitudeDegrees: 10.7583999,
            longitudeDegrees: 106.6599706,
            Rating: 4,
            Copyright: "duyan.vn",
            XPComment: "chuyên thiết kế bảng hiệu quảng cáo",
            XPAuthor: "Quảng Cáo Duy An",
            XPKeywords: [
                "bảng hiệu quảng cáo",
                "hộp đèn quảng cáo",
                "hộp đèn ép nổi",
                "hộp đèn siêu mỏng",
                "mặt dựng alu",
                "bảng đèn led",
                "in kỹ thuật số",
                "in offset",
                "vật phẩm quảng cáo",
            ],
        },
        cftf: {
            logos: [
                {
                    resize: 40,
                    margin: 50,
                    opacity: 65,
                    title: "logo 1",
                    src: "./public/images/upload/profile/MEM000000012/logo-etecco.png",
                    latitudeDegrees: 10.7118299,
                    longitudeDegrees: 106.6557944,
                    Rating: 4,
                    Copyright: "xuyenadaithanh.com",
                    XPComment: "palang điện - máy tời điện - bảo hộ lao động",
                    XPAuthor: "Xuyên Á Đại Thành",
                    XPKeywords: [
                        "palang điện",
                        "máy tời điện",
                        "bảo hộ lao động",
                    ],
                    XPSubject: "palang điện;máy tời điện;bảo hộ lao động",
                },
            ],
            resize: false,
        },
        maxSize: 6 * 1024, //6MB
    },
    sms: {
        success: {
            update: "Cập nhật logo thành công!",
        },
    },
};
const df = cafe.default;

export default {
    name: "tool-file-metadata-logo",

    components: {},

    // this is state
    data() {
        return {
            hlog: this.$options.filters.hlog,
            cpo: this.$options.filters.cpo,
            vld: this.$options.filters.validate,
            selected: {},
            isValid: false,
            values: {
                visible: false,
                logo: null,
            },
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
        logos() {
            var main = this;
            let { ConfigToolFile } = main.$store.state.authen.config;
            ConfigToolFile = ConfigToolFile || main.cpo(df.cftf);
            let logos = [];
            for (let [i, item] of (ConfigToolFile.logos || []).entries()) {
                const {
                    resize,
                    margin,
                    opacity,
                    title,
                    src,
                    latitudeDegrees,
                    longitudeDegrees,
                    Rating,
                    Copyright,
                    XPComment,
                    XPAuthor,
                    XPKeywords,
                    children,
                } = item;
                let logo = {
                    index: i + 1,
                    resize,
                    margin,
                    opacity,
                    title,
                    src,
                    latitudeDegrees,
                    longitudeDegrees,
                    Rating,
                    Copyright,
                    XPComment,
                    XPAuthor,
                    XPKeywords,
                    children,
                };
                logos.push(logo);
            }
            logos.push({ index: 0, title: "none" });
            let a = main.cpo(df.selected);
            let b = logos[0];
            main.selected = Object.assign(a, b);
            main.$emit("onChange", main.cpo(b));

            return logos;
        },
    },

    methods: {
        async addLogo() {
            var main = this;
            main.hlog.start("logo.add", "start");
            main.selected = main.cpo(df.selected);
            main.values.visible = !main.values.visible;
        },
        async editLogo() {
            var main = this;
            main.hlog.start("logo.edit", "start", main.selected);
            main.values.visible = !main.values.visible;
        },
        removeKeyword(child) {
            var main = this;
            let { XPKeywords } = main.selected;
            if (!Array.isArray(XPKeywords)) return;
            XPKeywords = main.cpo(XPKeywords);
            XPKeywords.splice(XPKeywords.indexOf(child), 1);
            main.selected.XPKeywords = XPKeywords;
        },
        onLogoChange() {
            var main = this;
            main.$emit("onChange", main.cpo(main.selected));
        },
        async submit() {
            /*********|form validate|*********/
            var main = this;
            const { form, botImg } = this.$refs;
            if (!form || !botImg) return;
            main.isValid = form.validate();

            /*********|update load logo file|*********/
            main.hlog.start("submit", "start", main.selected);
            const dp = main.$store.dispatch;
            main.spinner.visible = true;
            const { member } = main.ua;
            if (!member || !main.isValid) return;
            const { MemberID } = member;
            if (!MemberID) return;
            let key = `/profile/${MemberID}`;
            let src = await botImg.handleUpload({ key });
            if (!src) return;
            if (!src.indexOf("/public")) src = `.${src}`;

            /*********|start update|*********/
            let a = main.selected.index;
            let b = df.selected.index;
            let action = a === b ? "addLogo" : "updateLogo";
            let sp = df.sp.tool.file.metadata[action];
            main.selected.src = src;
            let res = await dp(sp, main.selected);
            main.hlog.end("submit", "end", res);
            let text = res.error;
            if (text) return dp(df.sp.snb, { text, color: "error" });
            text = cafe.sms.success.update;
            dp(df.sp.snb, { text, color: "success" });
            main.spinner.visible = false;
            main.values.visible = false;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// tool.file.metadata.logo.vue